/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  width: 400px;
  max-width: 90%;
  margin: 15% auto;
  padding: 24px;
  border-radius: 8px;
  z-index: 1001;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 18px;
  margin-bottom: 16px;
`;

const Message = styled.p`
  font-size: 16px;
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  ${({ variant }) =>
    variant === 'confirm'
      ? `background-color: #597EF7; color: white;`
      : `background-color: white; color: #597EF7; border: 1px solid #597EF7`}
`;

const ConfirmationPopup = ({
  open,
  title = 'Are you sure?',
  message = 'This action cannot be undone.',
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  if (!open) return null;

  return (
    <Overlay>
      <Modal>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <ButtonGroup>
          <Button onClick={onCancel}>{cancelText}</Button>
          <Button variant="confirm" onClick={onConfirm}>
            {confirmText}
          </Button>
        </ButtonGroup>
      </Modal>
    </Overlay>
  );
};

export default ConfirmationPopup;
